// nbassist/services/send-http-request.service.ts

/**
 * ServerService(Local側), GoogleService(Cloud側) に共通的な部分を記述。
 * app.module.ts の providers にて Local/Cloud いずれを使うかを記述すること。
 */

import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpErrorResponse, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export abstract class SendHttpRequestService {

  constructor() { }

  // Local, Cloud にて必ず定義すべきメソッド
  abstract request<T>(path: string, reQdto: any): Observable<T>;
  abstract requestWithHeaders<T>(path: string, reQdto: any, headers: HttpHeaders): Observable<T>;
  abstract sendRequest<T>(path: string, reQdto: any, headers: HttpHeaders | null): Observable<T>;
  abstract errorHandler(resp: HttpErrorResponse): void;
}
